// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___2jpbh","content":"styles__content___sK8x4","hidden":"styles__hidden___20sv0"};